import { render, staticRenderFns, recyclableRender, components } from "./order-food.vue?vue&type=template&id=02a75f26&scoped=true&"
var renderjs
import script from "./order-food.vue?vue&type=script&lang=js&"
export * from "./order-food.vue?vue&type=script&lang=js&"
import style0 from "./order-food.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order-food.vue?vue&type=style&index=1&id=02a75f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a75f26",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order-food/order-food.vue"
export default component.exports